import { StyleSheet } from 'react-native';

import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        marginBottom: 8,
        alignSelf: 'flex-start',
    },
    oneLineTitle: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    tabletEmbeddedProgramTitleBlock: {
        marginLeft: 44,
    },
    title: {
        lineHeight: 24,
    },
    multilineTitleTextWidth: {
        maxWidth: widthPercentageToDP(441, 560, 560),
    },
    wideEmbeddedTitleText: {
        maxWidth: widthPercentageToDP(328),
    },
    titleArrowWrapper: {
        justifyContent: 'flex-end',
        paddingLeft: 5,
    },
});

export default styles;
